export const XLSX_UPLOAD_START:string = 'fileupload/XLSX_UPLOAD_START';
export const XLSX_UPLOAD_SUCCESS:string = 'fileupload/XLSX_UPLOAD_SUCCESS';
export const XLSX_UPLOAD_ERROR:string = 'fileupload/XLSX_UPLOAD_ERROR';
export const GENERATE_DEFAULT_FILE_REPORT_START:string = 'fileupload/GENERATE_DEFAULT_FILE_REPORT_START';
export const GENERATE_DEFAULT_FILE_REPORT_ERROR:string = 'fileupload/GENERATE_DEFAULT_FILE_REPORT_ERROR';
export const GENERATE_DEFAULT_FILE_REPORT_SUCCESS:string = 'fileupload/GENERATE_DEFAULT_FILE_REPORT_SUCCESS';
export const PING_S3_URL = 'fileupload/PING_S3_URL';
export const PING_S3_URL_TIMEOUT = 'fileupload/PING_S3_URL_TIMEOUT';